import { getEventTypeFromDescription } from "../helpers";
import { toDate } from "../../../helpers/date";

export const processEvent = ({ event, timezone, dateTimeFormat }) => {
    const eventType = getEventTypeFromDescription(event.description);
    const displayDate = toDate({ date: event.datetime, timezone }).format(dateTimeFormat);

    return {
        ...event,
        type: eventType,
        displayDate: displayDate,
        uniqueKey: `${displayDate}-${eventType}`,
    };
};
